<template>
  <zm-dialog
    :visible="visible"
    :append-to-body="useZoomUIAppendToBody"
    class="opc-open-invoice-dialog"
    :class="isIframesModal ? 'opc-open-invoice-modal-dialog' : 'opc-open-invoice-full-dialog'"
    :show-close="!isIframesModal"
    top="8vh"
    @close="handleCancel">
    <NavBack v-if="isIframesModal" :backHandler="handleCancel" class="opc-open-invoice-modal-dialog__back"
             slot="title" />
    <div class="opc-open-invoice-dialog__body--wrapper">
      <div v-loading="loading" v-show="loading" class="opc-open-invoice-dialog__loading-wrapper"></div>
      <template v-show="!loading">
        <iframe
          v-if="usePdfPreview"
          ref="fileLoadContainer"
          class="opc-open-invoice-dialog__iframe"
          :src="pdfLink"
        />
        <div v-else class="opc-open-invoice-dialog__img--wrapper">
          <img ref="fileLoadContainer" class="opc-open-invoice-dialog__img" :src="imgLink" />
        </div>
      </template>
    </div>
  </zm-dialog>
</template>

<script>
import NavBack from '@/components/nav-back.vue';
import { isEmptyVal } from '@/utils';
import {
  disabledInvoiceUseLoadEvent,
  usePdfReadWithOpenInvoice,
  useZoomUIAppendToBody,
} from '@/views/config/shopping-cart/open-invoice/constant';
import { isBrowserHasPDFViewer } from '@/views/config/shopping-cart/open-invoice/helper';

export default {
  components: { NavBack },
  props: {
    invoiceNumber: String,
    visible: Boolean,
  },
  data() {
    return {
      loading: false,
      haveAppendToBody: false,
      useZoomUIAppendToBody,
    };
  },
  computed: {
    isIframesModal() {
      return this.$context.is.modal;
    },
    pdfLink() {
      return `/billing/payment-history/v1/invoicepdf?invoiceNumber=${this.invoiceNumber}&preview=true`;
    },
    imgLink() {
      return `/billing/payment_history/invoicepdf/image?invoiceNumber=${this.invoiceNumber}`;
    },
    watchValue() {
      return {
        link: this.pdfLink,
        visible: this.visible,
      };
    },
    usePdfPreview() {
      if (!isEmptyVal(usePdfReadWithOpenInvoice)) {
        return usePdfReadWithOpenInvoice;
      }

      return isBrowserHasPDFViewer();
    },
  },
  methods: {
    handleCancel() {
      this.$emit('close');
    },
    hiddenLoading() {
      this.loading = false;
    },
    showLoading() {
      this.loading = true;
    },
    handlerLoadEvent() {
      if (disabledInvoiceUseLoadEvent) return;
      this.showLoading();

      this.$nextTick(() => {
        const $fileLoadContainerEle = this.$refs?.fileLoadContainer;
        if ($fileLoadContainerEle) {
          $fileLoadContainerEle.removeEventListener('load', this.hiddenLoading);
          $fileLoadContainerEle.addEventListener('load', this.hiddenLoading);
        }
      });
    },
  },
  watch: {
    watchValue: {
      immediate: true,
      handler(newVal, oldVal) {
        if ((newVal?.link && newVal?.link !== oldVal?.link) && newVal?.visible) {
          this.handlerLoadEvent();
        }
      },
    },
    visible: {
      handler(val) {
        if (useZoomUIAppendToBody) return;
        // In order to avoid re-rendering of the iframe due to reflow, the backend API will be called every time.
        // Do not use the appendToBody function that comes with the dialog.
        if (!this.haveAppendToBody && val && this.$el) {
          document.body.appendChild(this.$el);
          this.haveAppendToBody = true;
        }
      },
    },
  },
  destroyed() {
    if (this.haveAppendToBody && this.$el && this.$el.parentNode) {
      this.$el.parentNode.removeChild(this.$el);
    }
  }
};
</script>

<style lang="scss">
@import '@zoom/billing-responsive/styles/responsive.scss';

.opc-open-invoice-dialog {
  .zm-dialog {
    padding: 20px 20px 0px 20px !important;
  }

  /** full screen modal checkout */
  &.opc-open-invoice-full-dialog {
    .zm-dialog {
      width: 858px;
      height: calc(100vh - 150px);

      @include media(tablet) {
        width: calc(100% - 24px) !important;
      }

      @include media(mobile) {
        height: 86% !important;
      }

      @include media(desktop, tablet) {
        &__body {
          margin-top: 16px;
          height: calc(100% - 32px);
        }

        &__headerbtn {
          top: 16px;
          right: 16px;
        }
      }
    }
  }

  /** only for modal checkout */
  &.opc-open-invoice-modal-dialog {
    .zm-dialog {
      width: 100% !important;
      margin-top: 0 !important;
      margin-bottom: 0 !important;
      height: 100% !important;
      max-width: 100%;
      border-radius: 0;
      overflow: auto;
      scrollbar-width: none;

      .zm-dialog__header {
        padding-bottom: 4px !important;

        .opc-open-invoice-modal-dialog__back {
          transform: translateY(-3px);
        }
      }
    }
  }

  &__body--wrapper {
    overflow: hidden;
    width: 100%;
    height: 100%;
  }

  &__loading-wrapper {
    width: 100%;
    height: 100%;
  }

  &__iframe {
    width: 100%;
    height: 100%;
  }

  &__img--wrapper {
    height: 100%;
    width: 100%;
    overflow: auto;
  }

  .zm-dialog__headerbtn {
    .zm-dialog__close {
      font-size: 20px;
    }
  }
}
</style>
